import { PageHeader } from "@/pages/layoutChrome";
import DatosMaestrosHubContent from "@/components/datosMaestros/DatosMaestrosHubContent";

/**
 * Hub transversal de datos maestros — entrada única al catálogo fiscal y utilidades SAT base.
 * Cada tarjeta respeta el entitlement del módulo dueño; el hub en sí es visible en el workspace.
 */
export default function DatosMaestrosHub() {
  return (
    <>
      <PageHeader
        title="Datos Maestros"
        subtitle="Catálogo fiscal compartido y utilidades SAT base. Cada función respeta el plan contratado por módulo."
        breadcrumb={["Datos Maestros"]}
      />
      <DatosMaestrosHubContent />
    </>
  );
}
